import { Component, OnInit } from '@angular/core';
import { AuthService } from './modules/auth/services/auth.service';

@Component({
  selector: 'app-public-auth-root-redirect',
  template: '',
})
export class PublicAuthRootRedirectComponent implements OnInit {
  constructor(private authService: AuthService) {}

  ngOnInit(): void {
    if (this.authService.currentUserValue?.id) {
      this.authService.syncSessionAndEnterPortal('/');
      return;
    }
    window.location.replace('/auth/sign-in');
  }
}
